<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                Volver
              </a>
            </div>
            <h3 class="page-title">Estudio de Cumplimiento:</h3>
        </div>
    </div>
  </div>

  <!-- Invoice Logo -->
  <div class="row">
    <div class="col-md-6">
      <label for="busca" class="col-form-label">Bucar empresa</label>
      <input
        class="form-control"
        type="text"
        id="buscar"
        placeholder="Buscar..."
        [(ngModel)]="searchTerm"
        (input)="buscar()"
      >
    </div>
    <div class="col-md-6">
      <label for="estadol" class="col-form-label">Estado</label>
      <select class="form-select" id="estado" name="estado" (change)="consulta_combos()">
        <option *ngFor="let ed of estado" [value]="ed.id_estado" [selected]="ed.id_estado == sel_edo ? true : false">
          {{ed.nombre}}
        </option>
      </select>
    </div>
  </div>
  <hr class="text-dark">




  <!-- end page title -->

  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr class="table-primary">
            <th scope="col">N°</th>
            <th scope="col">Rif</th>
            <th scope="col">Razón Social</th>
            <th scope="col">Tipo</th>
            <th scope="col">Año</th>
            <th class="text-center">Estudio de Cumplimiento</th>
            <th class="text-center">Certificado de Cumplimiento</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of filteredResultado; let i = index">
            <th scope="row">{{i+1}}</th>
            <td>{{r.identificacion}}</td>
            <td>{{r.nombre}}</td>
            <td>C.A/S.A/S.A.C.A/S.R.L</td>
            <td>{{r.ano}}</td>
            <td class="text-center">
              <a style="cursor: pointer;" class="btn btn-info" title="Estudio de Cumplimiento" (click)="imprimir(r.id_organizacion)"><i class="bi bi-file-earmark-break"></i></a>
            </td>
            <td class="text-center">
              <a style="cursor: pointer;" class="btn btn-primary" title="Certificado de Cumplimiento"><i class="bi bi-file-earmark-break"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>



